import { EllipsisVerticalIcon, TrashIcon } from '@heroicons/react/24/outline';
import { mergeAttributes, Node, NodeViewContent, NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';

import { Icon } from '@/components/core/Icon';

const DraggableNodeView = (props: any) => {
    const isEditable = props.editor.isEditable;

    const handleDeleteClick = () => {
        if (isEditable) {
            props.deleteNode();
        }
    };

    return (
        <NodeViewWrapper className="tw-flex tw-flex-1 tw-bg-white tw-drop-shadow tw-p-2 tw-mt-1 tw-rounder-sm">
            {isEditable && <div
                className="tw-relative tw-cursor-grab tw-t-0"
                contentEditable="false"
                draggable="true"
                data-drag-handle
            >
                <Icon
                    icon={EllipsisVerticalIcon}
                    size='sm'                />
            </div>}
            <NodeViewContent className="tw-flex-1" />

            {isEditable && <div
                className="tw-relative tw-cursor-pointer"
                contentEditable="false"
                onClick={handleDeleteClick}
            >
                <Icon
                    icon={TrashIcon}
                    size='sm'
                />
            </div>}
        </NodeViewWrapper>
    );
};

const DraggableItem = Node.create({
    name: 'draggableNode',
    group: 'draggable',
    content: 'block+',
    defining: true,
    draggable: true,
    isolating: true,

    parseHTML() {
        return [
            {
                tag: '*',
                getAttrs(node) {
                    if ( node instanceof HTMLElement) {
                        const type = node.getAttribute('data-type');
                        if ( type === 'draggable-node' ) {
                            return null;
                        }
                    }
                    return false;
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'draggable-node' }), 0];
    },

    addNodeView() {
        return ReactNodeViewRenderer(DraggableNodeView);
    },
});

export default DraggableItem;
